import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Menu, X, LogIn } from "lucide-react";
import { BRAND } from "@/lib/brand";

const links = [
  { to: "/pousadas", label: "Pousadas", testid: "nav-public-pousadas" },
  { to: "/contato", label: "Contato", testid: "nav-public-contato" },
];

export function PublicHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Fecha menu mobile ao navegar.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="public-header"
      className={`sticky top-0 z-40 w-full transition-colors ${
        scrolled ? "bg-[#F5F1E8]/95 backdrop-blur border-b border-[#083A6B]/15" : "bg-[#F5F1E8] border-b border-[#083A6B]/10"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 lg:h-20 flex items-center justify-between gap-6">
        {/* Logo oficial Rede Hospeda. Fallback neutro para desenvolvimento. */}
        <Link to="/" data-testid="public-brand" className="flex items-center gap-3 group">
          {BRAND.logoUrl ? (
            <img
              src={BRAND.logoUrl}
              alt={BRAND.name}
              className="h-9 lg:h-11 w-auto"
              width="200"
              height="80"
            />
          ) : (
            <span className="font-public-title text-xl text-[#083A6B] font-bold tracking-tight">
              {BRAND.name}
            </span>
          )}
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#083A6B]" : "text-stone-600 hover:text-[#083A6B]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/login"
            data-testid="nav-public-entrar"
            className="inline-flex items-center gap-1.5 text-sm text-stone-600 hover:text-[#083A6B]"
          >
            <LogIn size={14} /> Entrar
          </Link>
          <Link
            to="/pousadas"
            data-testid="nav-public-cta"
            className="inline-flex items-center h-10 px-5 rounded-md bg-[#083A6B] hover:bg-[#052B50] text-white text-sm font-medium transition-colors"
          >
            Conhecer pousadas
          </Link>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="public-mobile-menu-toggle"
          className="lg:hidden w-10 h-10 rounded-md border border-stone-200 flex items-center justify-center text-stone-700 bg-[#F5F1E8]"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="public-mobile-menu"
          className="lg:hidden border-t border-stone-200 bg-[#F5F1E8]"
        >
          <div className="px-5 py-4 space-y-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                className={({ isActive }) =>
                  `block px-3 py-3 rounded-md text-sm font-medium ${
                    isActive ? "bg-[#083A6B]/8 text-[#083A6B]" : "text-stone-700 hover:bg-stone-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/login"
              data-testid="nav-public-entrar-mobile"
              className="block px-3 py-3 rounded-md text-sm font-medium text-stone-700 hover:bg-stone-100"
            >
              Entrar
            </Link>
            <Link
              to="/pousadas"
              data-testid="nav-public-cta-mobile"
              className="block mt-2 w-full text-center h-11 leading-[44px] rounded-md bg-[#083A6B] text-white text-sm font-medium"
            >
              Conhecer pousadas
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
